import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationCoreModule } from "../../core/core.module";
import { NotificationBarComponent } from "./notification-bar.component";



@NgModule({
  declarations: [
    NotificationBarComponent
  ],
  imports: [
    CommonModule,
    AuthenticationCoreModule,
    NgbAlertModule
  ],
  exports: [
    NotificationBarComponent
  ]
})
export class NotificationBarModule { }
